import { Box, IconButton, styled, SvgIconProps, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { lazy, useEffect, useMemo, useState } from 'react'
import { setLoading, unsetLoading } from '../../store/loading/loading.slice'
import { useDispatch, useSelector } from 'react-redux'
import { activityList, collaborationNetworkType, FrontApi, sendFormPoll, USER_TYPE } from '../../api/front-api/front.api'
import BannerSlide from '../../components/banner-slide/BannerSlide'
import { MainContainer } from '../../components/container/container'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import FeedIcon from '@mui/icons-material/Feed';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import EmailIcon from '@mui/icons-material/Email';
import EditNotificationsIcon from '@mui/icons-material/EditNotifications';
import MovieIcon from '@mui/icons-material/Movie';
import { ActivityCard, CollaborationNetworkWebsite, CommentWebsite, FacebookPageEmbed, PollVoteCardWebsite } from './components/component'
import moment from 'moment'
import { RootState } from '../../store/store'
import { ImageContent } from '../../assets/background/background'
import { Link, useNavigate } from 'react-router-dom'
import { routeName } from '../../routes/routeName'
import Hashids from 'hashids'
import { BANNER_TYPE } from '../cms-website/website-structure/content/enum/content.enum'
import { alertError } from '../../components/alert/swal'
import { produce } from 'immer'
import CastForEducationIcon from '@mui/icons-material/CastForEducation';
import VideoChatIcon from '@mui/icons-material/VideoChat';
import FolderIcon from '@mui/icons-material/Folder';
import PeopleIcon from '@mui/icons-material/People';
import BadgeIcon from '@mui/icons-material/Badge';
import { useTranslation } from 'react-i18next'
import { getToken, getTokenMember } from '../../utils/app.utils'





type Props = {}
type menuWebsiteProps = {
    id_key: number;
    icon: React.ComponentType<SvgIconProps>;
    backgroundColor: string;
    iconColor: string;
    menuName: string;
    permission: boolean;
    menu_path?: string;
    user_type: string[];
}
const ContainerBox = styled(Box)(({ theme }) => ({
    width: "100%",
    margin: "0 auto",
    maxWidth: "1440px",
    [theme.breakpoints.down('xl')]: {
        maxWidth: "1240px"
    },
    [theme.breakpoints.down('lg')]: {
        maxWidth: "100%"
    },
    gap: 2,
    display: "flex",
    flexDirection: 'column',
}))
const Home: React.FC = ({ }: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const profile = useSelector((state: RootState) => state.profile.profile) as any;
    const hash_ids = new Hashids(process.env.REACT_APP_SECRET_SALT, 50);

    const user_type = profile?.user_type as USER_TYPE;

    const base_url = useSelector((state: RootState) => state.api.image_api);
    const matches = useMediaQuery(theme.breakpoints.down('md'));

    const [banner_data, set_banner_data] = useState<any[]>([]);
    const [banner_activity, set_banner_activity] = useState<any[]>([]);
    const [activity_data, set_activity_data] = useState<any[]>([]);
    const [form_poll, set_form_poll] = useState<any[]>([]);
    const [comment_data, set_comment_data] = useState<any[]>([]);
    const [collaboration_network_data, set_collaboration_network_data] = useState<any[]>([])

    const handleChangeFormPoll = (id_form_poll: number, id_form_poll_choice: number) => {
        set_form_poll(prev =>
            produce(prev, draft => {
                const targetPoll = draft?.find(p => p.id_form_poll === id_form_poll);
                if (!targetPoll) return;
                if (targetPoll.form_poll_choice?.length > 0) {
                    const targetChoice = targetPoll.form_poll_choice.find(
                        (x: any) => x.id_form_poll_choice === id_form_poll_choice
                    );
                    if (targetChoice) {
                        targetChoice.id_form_poll_choice_select = id_form_poll_choice;
                    }
                }
            })
        );
    };

    const menu_website = useMemo((): menuWebsiteProps[] => {
        return [
            {
                id_key: 1,
                backgroundColor: "#ECF0FF",
                icon: CalendarMonthIcon,
                iconColor: "#6178FF",
                menuName: t("HOME_PAGE_CLASS_SCHEDULE_SYSTEM"),
                permission: false,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER, USER_TYPE.STUDENT]
            },
            {
                id_key: 2,
                backgroundColor: "#E9F6ED",
                icon: AssignmentIndIcon,
                iconColor: "#3BB065",
                menuName: "E-Advisor",
                permission: false,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER],
                menu_path: routeName.advisor.manageAdvisorRequest
            },
            {
                id_key: 3,
                backgroundColor: "#FEF2EC",
                icon: LibraryBooksIcon,
                iconColor: "#F3824E",
                menuName: "E-VISA",
                permission: false,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.STUDENT],
                menu_path: routeName.request_form.visa_request
                // รอ PATH
            },
            {
                id_key: 4,
                backgroundColor: "#FFEFF0",
                icon: FeedIcon,
                iconColor: "#FF7C96",
                menuName: "E-Thesis",
                permission: false,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER, USER_TYPE.STUDENT],
                menu_path: routeName.cms.EThesisLibrary
            },
            {
                id_key: 5,
                backgroundColor: "#FCEBFF",
                icon: StarBorderIcon,
                iconColor: "#E342FF",
                menuName: t('HOME_PAGE_TEACHER_EVALUATION_SYSTEM_FROM_STUDENTS'),
                permission: false,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER, USER_TYPE.STUDENT],
                menu_path: routeName.advisor.TeacherEvaluationScores
            },
            {
                id_key: 6,
                backgroundColor: "#FEF7EE",
                icon: EmailIcon,
                iconColor: "#F5B559",
                menuName: t("HOME_PAGE_STUDENT_COMPLAINT_SYSTEM"),
                permission: false,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.STUDENT],
                menu_path: routeName.cms.complaintSystem
            },
            {
                id_key: 7,
                backgroundColor: "#ECF0FF",
                icon: EditNotificationsIcon,
                iconColor: "#6178FF",
                menuName: t("HOME_PAGE_COMPLAINT_SYSTEM"),
                permission: false,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER, USER_TYPE.STUDENT],
                menu_path: routeName.students.complaintSubmit
            },
            {
                id_key: 8,
                backgroundColor: "#FCEBFF",
                icon: MovieIcon,
                iconColor: "#E342FF",
                menuName: "E-Library",
                permission: false,
                menu_path: routeName.e_library.manage_books,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER, USER_TYPE.STUDENT]
            },
            {
                id_key: 9,
                backgroundColor: "#ECF0FF",
                icon: CastForEducationIcon,
                iconColor: "#6178FF",
                menuName: "E-Learning",
                permission: false,
                menu_path: routeName.students.OnlineCourse,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER, USER_TYPE.STUDENT]
            },
            {
                id_key: 10,
                backgroundColor: "#E9F6ED",
                icon: VideoChatIcon,
                iconColor: "#3BB065",
                menuName: "E-Meeting",
                permission: false,
                menu_path: routeName.cms.MeetingCalendar,
                user_type: [USER_TYPE.EMPLOYEE, USER_TYPE.MEMBER, USER_TYPE.STUDENT]
            },
            {
                id_key: 11,
                backgroundColor: "#FEF2EC",
                icon: FolderIcon,
                iconColor: "#F3824E",
                menuName: "E-EdPex",
                permission: false,
                menu_path: routeName.cms.edpexResultDisplay,
                user_type: [USER_TYPE.EMPLOYEE]
            },
            {
                id_key: 12,
                backgroundColor: "#FFEFF0",
                icon: PeopleIcon,
                iconColor: "#FF7C96",
                menuName: "E-HR",
                permission: false,
                menu_path: routeName.cms.PersonnelManagement,
                user_type: [USER_TYPE.EMPLOYEE]
            },
            {
                id_key: 13,
                backgroundColor: "#FEF7EE",
                icon: BadgeIcon,
                iconColor: "#F5B559",
                menuName: "E-Admission",
                permission: false,
                menu_path: routeName.main.admission,
                user_type: [USER_TYPE.MEMBER, USER_TYPE.STUDENT, USER_TYPE.EMPLOYEE]
            },
        ]
    }, [])


    const handleGetBannerSlide = async () => {
        dispatch(setLoading());
        await FrontApi.banner({ limit: 10, page: 1, banner_group: 'HOME' }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_banner_data(response);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleGetMostPopularPollVote = async () => {
        await FrontApi.formPollList({ limit: 6, page: 1 }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_form_poll(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetCollaborationNetwork = async () => {
        let query: collaborationNetworkType = {
            page: 1,
            limit: 15
        }
        await FrontApi.collaborationNetwork(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_collaboration_network_data(response);
                // console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetCommentData = async () => {
        await FrontApi.commentList().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_comment_data(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetActivityList = async () => {
        let query: activityList = {
            page: 1,
            limit: 4,
            // sortBy: 'activity_start_date',
            // sortType: 'asc'
        }
        await FrontApi.activity(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_activity_data(response);
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const handleGetBannerSlideActivity = async () => {
        dispatch(setLoading());
        await FrontApi.banner({ limit: 5, page: 1, banner_group: 'ACTIVITY' }).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                set_banner_activity(response)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleSendForm = async (id_form_poll: number, id_form_poll_choice: number, auth_required: boolean) => {
        const body: sendFormPoll = {
            auth_required,
            id_form_poll,
            id_form_poll_choice
        }
        dispatch(setLoading());
        await FrontApi.sendForm(body).then((res) => {
            if (res.status < 300) {
                handleGetMostPopularPollVote();
            }
        }).catch((err) => {
            alertError(t("HOME_PAGE_VOTING_FAILED"), err?.response?.data?.message || t("HOME_PAGE_VOTING_FAILED._PLEASE_TRY_AGAIN."))
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    // console.log(profile, 'profile')

    useEffect(() => {
        handleGetCollaborationNetwork();
        handleGetActivityList();
        handleGetBannerSlide();
        handleGetBannerSlideActivity();
        handleGetMostPopularPollVote();
        handleGetCommentData();
    }, [])

    return (
        <div>
            <BannerSlide
                banner_slide={banner_data || []}
                banner_type={BANNER_TYPE.TYPE_ONE}
            />


            <MainContainer>
                <ContainerBox data-aos="fade-up"
                    data-aos-anchor-placement="center-bottom">
                    <Box className="w-full gap-24 flex-col xl:flex-row flex justify-center md:justify-start items-center px-4 md:px-0">
                        <Box className="w-full max-w-fit flex flex-col gap-4 py-10 px-5 md:px-0">
                            <Typography sx={{
                                fontSize: "clamp(20px, 4vw, 48px)",
                            }}>
                                Smart IBSC
                            </Typography>
                            <Box>
                                <Typography>
                                    {t("HOME_PAGE_INTELLIGENT_SYSTEMS_FOR_EDUCATION")}
                                </Typography>
                                <Typography>
                                    {t("HOME_PAGE_INTERNATIONAL_BUDDHIST_COLLEGE")}
                                </Typography>
                            </Box>
                        </Box>
                        <Box className="flex flex-wrap gap-4">
                            {/* {menu_website?.filter((x) => x.user_type.some((y) => y === user_type)).map((list) => { */}
                            {menu_website?.filter((x) => {
                                if (getTokenMember() || getToken()) {
                                    return x.user_type.includes(user_type)
                                }
                                return true
                            }).map((list) => {
                                return (
                                    <Link to={list?.menu_path || "/"}>
                                        <Box
                                            width={114}
                                            className="flex gap-2 justify-center items-center flex-col"
                                            key={list.id_key}
                                        >
                                            <Box
                                                className="flex justify-center items-center"
                                                width={"80px"}
                                                height={"80px"}
                                                sx={{
                                                    borderRadius: "16px",
                                                    backgroundColor: list.backgroundColor,
                                                }}
                                            >
                                                <IconButton>
                                                    {<list.icon sx={{ color: list.iconColor, fontSize: "2.4rem" }} />}
                                                </IconButton>
                                            </Box>
                                            <Typography
                                                textAlign="center"
                                                sx={{
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    minHeight: "40px",
                                                    lineHeight: "20px",
                                                }}
                                            >
                                                {list.menuName}
                                            </Typography>
                                        </Box>
                                    </Link>
                                );
                            })}
                        </Box>
                    </Box>

                    <Box sx={{ my: 7, px: { xs: 2, xl: 0 } }}>
                        <ActivityCard
                            onViewAllClick={() => navigate(routeName.main.activity)}
                            data_slide={banner_activity?.map((list) => {
                                const is_current_tab = list?.banner_status_open === 'current_tab';
                                const url_img = list?.media_file_path ? `${base_url}/${list?.media_file_path}${list?.media_file_name}` : ImageContent.noImage
                                const link_url = String(list?.banner_link || "").startsWith("http") ? list?.banner_link : routeName.main.contentDetail.replace(":content_no", list?.banner_link);
                                return {
                                    id: list?.id_banner,
                                    url: link_url,
                                    current_tab: is_current_tab,
                                    // onClick:()=>
                                    img_url: url_img
                                }
                            })}
                            activity_data={
                                activity_data?.map((list) => {
                                    const id = hash_ids.encode(list?.id_content);
                                    return {
                                        to: routeName.main.activityDetail.replace(":id", id),
                                        detail: list?.activity_category_name,
                                        end_time: moment(list?.activity_end_date).format("HH:mm"),
                                        position: "",
                                        start_date: list?.activity_start_date,
                                        start_time: moment(list?.activity_start_date).format("HH:mm"),
                                        title: list?.content_name,
                                    }
                                })
                            }
                            detail={t("HOME_PAGE_FOLLOW_IMPORTANT_ACTIVITIES_OF_IBSC_STUDENTS_AND_FACULTY_HERE.")}
                            title={t("HOME_PAGE_IBSC_ACTIVITY_CALENDAR")} />
                    </Box>
                </ContainerBox>
            </MainContainer>
            {form_poll?.length > 0 && (
                <PollVoteCardWebsite
                    handleSendForm={handleSendForm}
                    data={form_poll}
                    handleChangeFormPoll={handleChangeFormPoll}
                />
            )}

            <ContainerBox pb={10}>
                <CommentWebsite
                    detail={t("HOME_PAGE_ALUMNI'S_OPINIONS_ON_THE_INTERNATIONAL_BUDDHIST_COLLEGE_(IBSC)")}
                    title={t("HOME_PAGE_COMMENTS_FROM_ALUMNI")}
                    data={comment_data}
                />

                <Box className="grid grid-cols-12 gap-4 min-h-[529px]">
                    <Box className="col-span-12 xl:col-span-4 flex justify-center items-center px-4">
                        <FacebookPageEmbed width={!matches ? 406 : 500} height={500} pageUrl={'https://www.facebook.com/ibsc.mcu.ac.th'} />
                    </Box>
                    <Box className="col-span-12 xl:col-span-8">
                        <CollaborationNetworkWebsite
                            data={collaboration_network_data?.map((list) => {
                                const img_url = list?.media_file_path ? `${base_url}/${list?.media_file_path}${list?.media_file_name}` : ImageContent.noImage
                                return {
                                    id: list?.id_collaboration_network,
                                    img_url: img_url,
                                    link: list?.collaboration_network_link,
                                }
                            })}
                            detail={t("HOME_PAGE_WE_CONNECT_KNOWLEDGE_FROM_A_NETWORK_OF_TEACHERS_AND_EDUCATIONAL_PARTNERS_ACROSS_THE_COUNTRY.")}
                            sub_detail={t("HOME_PAGE_TO_RAISE_THE_STANDARDS_OF_LEARNING_IN_ALL_DIMENSIONS")}
                            title={t("HOME_PAGE_COLLABORATION_NETWORK_WITH_TEACHERS_AND_EDUCATIONAL_ORGANIZATIONS")}
                        />
                    </Box>
                </Box>
            </ContainerBox>
        </div>
    )
}

export default Home